var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"type":"text","placeholder":"106.58","disabled":_vm.disabled},on:{"change":_vm.change},model:{value:(_vm.money),callback:function ($$v) {_vm.money=$$v},expression:"money"}},[_c('i',{staticClass:"fas fa-fw fa-dollar-sign mt-3",attrs:{"slot":"prefix"},slot:"prefix"})])
}
var staticRenderFns = []

export { render, staticRenderFns }